import { render, staticRenderFns } from "./SiderRouteTravelDates.vue?vue&type=template&id=1deff35e&scoped=true&"
import script from "./SiderRouteTravelDates.vue?vue&type=script&lang=js&"
export * from "./SiderRouteTravelDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deff35e",
  null
  
)

export default component.exports